import React from "react";
import SEO from "../components/SEO";

const Shipping = () => {
  return (
    <>
      <SEO
        title='Shipping'
        description='Blank Beanies'
        keywords='Blank Beanies'
      />
      <div className="relative bg-gradient-to-br from-[#f1f7f5] via-white to-[#ecf3f1] overflow-hidden">

        {/* Decorative blur */}
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#437d6a]/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#437d6a]/10 rounded-full blur-3xl" />

        <div className="relative container mx-auto px-4 py-24 max-w-6xl">

          {/* Header */}
          <div className="text-center mb-24">
            <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/70 backdrop-blur border border-[#437d6a]/20 text-[#437d6a] font-semibold shadow-sm">
              Shipping & Delivery
            </div>

            <h1 className="mt-8 text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tight">
              Shipping Policy
            </h1>

            <p className="mt-8 max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed">
              Clear information about production, shipping timelines, and delivery
              for{" "}
              <span className="font-semibold text-[#437d6a]">
                Personalised Hat Patches
              </span>.
            </p>
          </div>

          {/* Glass Card */}
          <div className="bg-white/80 backdrop-blur-xl rounded-[32px] shadow-2xl border border-gray-200 p-10 md:p-16 space-y-20">

            {/* Intro */}
            <p className="text-xl text-gray-700 leading-relaxed">
              This Shipping Policy explains how{" "}
              <span className="font-semibold text-gray-900">
                Personalised Hat Patches
              </span>{" "}
              processes, produces, and delivers custom orders. By placing an
              order, you agree to the terms below.
            </p>

            {/* Sections */}
            {[
              {
                icon: "🧵",
                title: "Production Time",
                body: (
                  <>
                    <p>
                      All products are custom-made. Production starts after
                      artwork approval and payment confirmation.
                    </p>
                    <p>
                      Standard production time is{" "}
                      <span className="font-semibold text-[#437d6a]">
                        7–10 business days
                      </span>
                      , depending on design complexity and order size.
                    </p>
                    <p>Rush production may be available upon request.</p>
                  </>
                ),
              },
              {
                icon: "🚀",
                title: "Shipping Time",
                body: (
                  <>
                    <p>
                      Once production is complete, orders ship via trusted courier
                      partners.
                    </p>
                    <ul className="grid sm:grid-cols-2 gap-3 mt-3 text-gray-700">
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        🇺🇸 USA & Canada: 3–7 days
                      </li>
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        🇬🇧 UK & Europe: 5–10 days
                      </li>
                      <li className="bg-[#f1f7f5] rounded-xl px-4 py-2">
                        🌍 International: 7–14 days
                      </li>
                    </ul>
                  </>
                ),
              },
              {
                icon: "💳",
                title: "Shipping Charges",
                body: (
                  <p>
                    Shipping costs are calculated at checkout based on location,
                    order size, and shipping method. Free shipping promotions may
                    apply.
                  </p>
                ),
              },
              {
                icon: "📦",
                title: "Order Tracking",
                body: (
                  <p>
                    You will receive a tracking email once your order ships.
                    Tracking updates may take up to 24 hours.
                  </p>
                ),
              },
              {
                icon: "🛃",
                title: "Customs & Taxes",
                body: (
                  <p>
                    International orders may be subject to customs duties or
                    import taxes, which are the customer’s responsibility.
                  </p>
                ),
              },
              {
                icon: "⚠️",
                title: "Incorrect Address",
                body: (
                  <p>
                    We are not responsible for delivery delays caused by incorrect
                    or incomplete shipping addresses.
                  </p>
                ),
              },
              {
                icon: "⏳",
                title: "Shipping Delays",
                body: (
                  <p>
                    Delays may occur due to courier issues, customs processing,
                    or peak seasons.
                  </p>
                ),
              },
            ].map((item, index) => (
              <section
                key={index}
                className="relative pl-10 border-l-4 border-[#437d6a] space-y-4"
              >
                <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                  <span className="text-2xl">{item.icon}</span>
                  {item.title}
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-3">
                  {item.body}
                </div>
              </section>
            ))}

            {/* Contact */}
            <section className="bg-gradient-to-br from-[#437d6a] to-[#356b5a] rounded-3xl p-10 text-white shadow-xl">
              <h2 className="text-2xl font-bold mb-4">Need Help?</h2>
              <p className="text-white/90 mb-6">
                Contact our support team for any shipping or delivery questions.
              </p>
              <div className="space-y-1 text-white/90">
                <p className="font-semibold">Personalised Hat Patches</p>
                <p>Email: support@personalisedhatpatches.com</p>
                <p>Phone: (703) 666-8193</p>
              </div>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-10 border-t">
              Last updated on 11/20/24
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Shipping;
